import {
  WSContainer,
  WSGrid,
  WSLayout,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { useHistory } from "react-router-dom";
import { ConfirmOrderPhysicalCard } from "../components/ConfirmOrderPhysicalCard";
import { WALLET_ROOT_PATH } from "../index";
import { useCardOrderedModal } from "../modals/OrderConfirmation/useCardOrderedModal";

export const RouteConfirmOrderPhysicalCard = () => {
  const history = useHistory();
  const cardOrderedModal = useCardOrderedModal();

  return (
    <WSLayout
      headerCenter={
        <WSText.ParagraphSm weight="medium">Order card</WSText.ParagraphSm>
      }
      smallHeader={true}
      onClose={() => {
        history.push(WALLET_ROOT_PATH);
      }}
      line
    >
      <WSContainer verticalPadding>
        <WSGrid>
          <WSGrid.Item span={{ m: "4" }} />
          <WSGrid.Item span={{ m: "4" }}>
            <ConfirmOrderPhysicalCard
              onOrdered={async () => {
                await cardOrderedModal.open();

                history.push(WALLET_ROOT_PATH);
              }}
            />
          </WSGrid.Item>
        </WSGrid>
      </WSContainer>
    </WSLayout>
  );
};
